import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { Button, TextDisplay } from "ia-react-ui-components";

const AnswerText = styled.p`
  word-break: break-all;
`;


export class GenerateSummary extends Component {
  constructor(props) {
    super();
  }

  linkToSection = sectionIndex => {
    const { t } = this.props;
    switch (sectionIndex) {
      case 1:
        return (
          <Link to="SectionOne">
            <Button id="1">{t("section_summary.section1")}</Button>
          </Link>
        );
      case 2:
        return (
          <Link to="SectionTwo">
            <Button id="2">{t("section_summary.section2")}</Button>
          </Link>
        );
      case 3:
        return (
          <Link to="SectionThree">
            <Button id="3">{t("section_summary.section3")}</Button>
          </Link>
        );
      case 4:
        return (
          <Link to="SectionFour">
            <Button id="4">{t("section_summary.section4")}</Button>
          </Link>
        );
      case 5:
        return (
          <Link to="SectionFive">
            <Button id="5">{t("section_summary.section5")}</Button>
          </Link>
        );
      case 6:
        return (
          <Link to="SectionSix">
            <Button id="6">{t("section_summary.section6")}</Button>
          </Link>
        );
      default:
        break;
    }
  };

  generateSummary = (question, groups) => {
    // Don't generate if group is hidden
    if (question.group !== undefined) {
      for (let i = 0; i < groups.length; i++) {
        for (let j = 0; j < question.group.length; j++) {
          if (question.group[j] === groups[i].name) {
            if (groups[i].hide === true) {
              return;
            } else {
              break;
            }
          }
        }
      }
    }

    switch (question.question_type) {
      case "date":
      case "text":
      case "mask":
      case "phone":
      case "amount":
      case "multiLineText":
        return (
          <React.Fragment>
            <h3>
              {this.props.interview.lang === "en"
                ? question.question_e
                : question.question_f}
            </h3>
            <AnswerText>{question.value}</AnswerText>
          </React.Fragment>
        );

      //filter on options based on language
      //as filter returns array, get first (and should be only) value
      // for dropdown, due to iA's component, values are stored as translation
      case "dropdown":
        return (
          <React.Fragment>
            <h3>
              {this.props.interview.lang === "en"
                ? question.question_e
                : question.question_f}
            </h3>
            <p>
              {this.props.interview.lang === "en"
                ? question.options_e.filter(
                    values => values.key === question.value
                  )[0].translation
                : question.options_f.filter(
                    values => values.key === question.value
                  )[0].translation}
            </p>
          </React.Fragment>
        );

      case "radioHide":
        return (
          <React.Fragment>
            <h3>
              {this.props.interview.lang === "en"
                ? question.question_e
                : question.question_f}
            </h3>
            <p>
              {this.props.interview.lang === "en"
                ? question.options_e.filter(
                    values => values.key === question.value
                  )[0].value
                : question.options_f.filter(
                    values => values.key === question.value
                  )[0].value}
            </p>
          </React.Fragment>
        );

      case "checkboxHide":
        return (
          <React.Fragment>
            <h3>
              {this.props.interview.lang === "en"
                ? question.question_e
                : question.question_f}
            </h3>

            <label>
              <Row>
                <div hidden={this.props.interview.lang === "en" ? false : true}>
                  {question.options_e.map((option, index) => {
                    return (
                      <Col sm="auto" key={index}>
                        {option} : {question.value[index] ? "Yes" : "No"}
                      </Col>
                    );
                  })}
                </div>
                <div hidden={this.props.interview.lang === "fr" ? false : true}>
                  {question.options_f.map((option, index) => {
                    return (
                      <Col sm="auto" key={index}>
                        {option} : {question.value[index] ? "Oui" : "Non"}
                      </Col>
                    );
                  })}
                </div>
              </Row>
            </label>
          </React.Fragment>
        );

      case "button":
        return;

      default:
        return;
    }
  };

  createTable = () => {
    var interview = this.props.interview;

    //Don't display the questions for the last page (the declaration) as part of the summary
    return interview.sections
      .filter(section => {
        if (section.section_id < 7 && section.hideSection !== true)
          return section;
      })
      .map((section, index) => {
        return (
          <React.Fragment key={index}>
            <h1>
              {this.props.interview.lang === "en"
                ? section.name_e
                : section.name_f}
            </h1>
            {section.questions.map((question, ind) => {
              if (question.value) {
                return (
                  <React.Fragment key={question.name}>
                    {this.generateSummary(question, section.groups)}
                  </React.Fragment>
                );
              }
            })}
            {this.linkToSection(section.section_id)}
            <br />
            <br />
          </React.Fragment>
        );
      });
  };

  render() {
    return <React.Fragment>{this.createTable()}</React.Fragment>;
  }
}
export default translate("translate")(GenerateSummary);
